import React, { memo } from "react";
import { BookingLabel } from "../../../../../types/VenueGroup";
import { EDSBadge } from "../../../../eds/EDSBadge";

type LabelListType = {
  data: BookingLabel[];
  loading?: boolean;
  noRecords: string;
};

const LabelList = ({ data, loading, noRecords }: LabelListType) => {
  if (data.length === 0) {
    return <>{noRecords}</>;
  }

  if (loading) {
    return (
      <>
        {data
          .filter((label) => label != null)
          .map((label, index) => (
            <div
              key={`loadingPill-${label?.id || index}`}
              className="BookingLabel flex-[0_0_auto]"
            >
              <EDSBadge
                variant="default"
                className="booking-label-badge bg-[var(--booking-type-color,hsl(var(--primary)))] text-[var(--booking-type-foreground,hsl(var(--primary-foreground)))] capitalize relative overflow-hidden whitespace-nowrap text-ellipsis flex justify-center items-center min-w-fit max-w-[150px] h-5"
                style={
                  {
                    "--booking-type-color": "#e5e7eb",
                    "--booking-type-foreground": "var(--black)"
                  } as React.CSSProperties
                }
              >
                <span className="booking-label-badge-text z-[1] text-xs font-bold text-[var(--black)] text-center leading-[1.2] break-words">
                  Loading...
                </span>
              </EDSBadge>
            </div>
          ))}
      </>
    );
  }

  return (
    <>
      {data
        .filter((label) => label != null)
        .map((label, index) => (
          <div
            key={`label-${label?.id || index}`}
            className="BookingLabel flex-[0_0_auto]"
          >
            <EDSBadge
              variant="default"
              className="booking-label-badge bg-[var(--booking-type-color,hsl(var(--primary)))] text-[var(--booking-type-foreground,hsl(var(--primary-foreground)))] capitalize relative overflow-hidden whitespace-nowrap text-ellipsis flex justify-center items-center min-w-fit max-w-[150px] h-5"
              style={
                {
                  "--booking-type-color": `#${label?.colour || "e5e7eb"}`,
                  "--booking-type-foreground": "var(--black)"
                } as React.CSSProperties
              }
            >
              <span className="booking-label-badge-text z-[1] text-xs font-bold text-[var(--black)] text-center leading-[1.2] break-words">
                {label?.label || "Unknown"}
              </span>
            </EDSBadge>
          </div>
        ))}
    </>
  );
};

export default memo<LabelListType>(LabelList);
